import { render, staticRenderFns } from "./PromotionSwiper.vue?vue&type=template&id=052e6cad&scoped=true"
import script from "./PromotionSwiper.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromotionSwiper.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PromotionSwiper.vue?vue&type=style&index=0&id=052e6cad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052e6cad",
  null
  
)

export default component.exports